import React from 'react';
import { Person, useDateHelper } from 'nekst-api';
import { ClientAppToggleWrapper } from 'feature-toggle';
import styles from './PortalInvitationInfo.module.scss';

function formatDateShort(date: Date, dateHelper: ReturnType<typeof useDateHelper>): string {
  return dateHelper.toDateTimeView(date).split(' ')[0];
}

export function PortalInvitationInfo(
  props: {
    person: Person,
  },
) {
  const dateHelper = useDateHelper();

  const { portalInvitationSentAt, portalInvitationAcceptedAt } = props.person;

  if (!portalInvitationSentAt) {
    return null;
  }

  if (portalInvitationAcceptedAt) {
    return (
      <ClientAppToggleWrapper>
        <div className={styles.portalInvitationInfo}>
          Portal Invitation Accepted: {formatDateShort(portalInvitationAcceptedAt, dateHelper)}
        </div>
      </ClientAppToggleWrapper>
    );
  } else {
    return (
      <ClientAppToggleWrapper>
        <div className={styles.portalInvitationInfo}>
          Portal Invitation Sent: {formatDateShort(portalInvitationSentAt, dateHelper)}
        </div>
      </ClientAppToggleWrapper>
    );
  }
}
